import { sharedLib } from "@shared/services/shared.service.ts";
import { ColumnsType } from "antd/es/table";
import Table from "common/Table/Table.tsx";
import React from "react";
import { ExternalAccountInvitation } from "@shared/types";
import {
  sortByNumberProperty,
  sortByStringProperty,
} from "@shared/utils/general.ts";
import InvitationActions from "features/configuration/InviteExternalUsers/InvitationActions.tsx";
import { formatDate } from "@shared/utils/date";
import Text from "common/Typography/Text";
import { DELETE_EXTERNAL_INVITATION_CACHE_KAY } from "features/configuration/InviteExternalUsers/constants.ts";
import InvitationStatusTag from "features/configuration/InviteExternalUsers/InvitationStatusTag.tsx";

const ManageInvitationsTable = () => {
  const { data, isLoading } =
    sharedLib.sharedApi.configuration.useGetAccountInvitesQuery();
  const deleteAccountInviteStatus =
    sharedLib.sharedApi.configuration.useDeleteAccountInviteMutation({
      fixedCacheKey: DELETE_EXTERNAL_INVITATION_CACHE_KAY,
    })[1];

  const getFormattedTime = (timestamp: number) => {
    return formatDate(timestamp, true, true);
  };

  const columns: ColumnsType<ExternalAccountInvitation> = [
    {
      title: "Account name",
      dataIndex: "name",
      showSorterTooltip: false,
      render: (name) => (
        <Text $ellipsis={true} style={{ maxWidth: MAX_NAME_WIDTH }}>
          {name}
        </Text>
      ),
      width: MAX_NAME_WIDTH,
      sorter: (a, b) => sortByStringProperty(a, b, "name"),
    },
    {
      title: "Creation",
      dataIndex: "creation_datetime",
      showSorterTooltip: false,
      defaultSortOrder: "descend",
      render: getFormattedTime,
      sorter: (a, b) => sortByNumberProperty(a, b, "creation_datetime"),
    },
    {
      title: "Expiration",
      dataIndex: "valid_to",
      showSorterTooltip: false,
      render: getFormattedTime,
      sorter: (a, b) => sortByNumberProperty(a, b, "valid_to"),
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (_, invitation) => (
        <InvitationStatusTag invitation={invitation} />
      ),
    },
    {
      title: "",
      dataIndex: "id",
      key: "action",
      width: 40,
      render: (_, inviteData) => (
        <InvitationActions invitationData={inviteData} />
      ),
    },
  ];

  return (
    <Table<ExternalAccountInvitation>
      columns={columns}
      dataSource={data}
      loading={isLoading || deleteAccountInviteStatus.isLoading}
      rowClassName="table-half-padding"
      rowKey={(invitation) => invitation.token}
    />
  );
};

export default ManageInvitationsTable;

const MAX_NAME_WIDTH = 180;
